import './styles.sass';

import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip as ReactTooltip } from 'react-tooltip';

import * as QueryParams from 'components/Explorer/models/query_params';
import useExplorerData, { Loading } from 'hooks/useExplorerData';
import useQueryParams from 'hooks/useQueryParams';
import useNavigateParams from 'hooks/useNavigateParams';

import QuickSearch from '../QuickSearch';

const Header = ({ onShowAdvancedSearch, logo, instanceName, onSelectShowMore }) => {
  const params = useQueryParams();
  const navigateParams = useNavigateParams();

  const { data, loading } = useExplorerData('metadata/query_description', params, { reloadOn: ['filters'] });

  const isLoading = loading === Loading.NOT_STARTED || loading === Loading.IN_PROGRESS;
  const title = data?.title ?? null;
  const titleHtml = { __html: I18n.t('Explorer.Header.title', { title }) };

  const selectResult = (filters) => {
    // mention_source_order only makes sense when filtering by Twitter; reset it
    // when other filters change so we don't end up sorting a non-Twitter list
    // by Twitter follower count.
    let next = QueryParams.withFilters(params, filters);
    if (params.mentionSourceOrder !== QueryParams.DEFAULT_MENTION_SOURCE_ORDER) {
      next = QueryParams.withMentionSourceOrder(next, QueryParams.DEFAULT_MENTION_SOURCE_ORDER);
    }
    navigateParams(next);
  };

  return (
    <>
      <header className="Explorer-Header">
        <ReactTooltip id="book-warning" effect="solid" />
        <div className="Explorer-Header-logo">
          <img src={logo} alt={instanceName} />
        </div>
        <div className="Explorer-Header-title">
          {window.current_user.books ? null : (
            <span
              className="Explorer-Header-book-warning"
              data-tooltip-id="book-warning"
              data-tooltip-content={I18n.t('Explorer.Header.book_warning')}
            />
          )}
          {isLoading ? (
            <span className="loading-message">{I18n.t('Explorer.Header.loading')}</span>
          ) : (
            <h1 className="description" dangerouslySetInnerHTML={titleHtml} />
          )}
        </div>
        <div className="Explorer-Header-edit-button">
          {!isLoading && (
            <button className="edit-button" onClick={onShowAdvancedSearch}>
              {I18n.t('Explorer.Header.edit')}
            </button>
          )}
        </div>
      </header>
      <QuickSearch onSelectResult={selectResult} onSelectShowMore={onSelectShowMore} />
    </>
  );
};

Header.propTypes = {
  onShowAdvancedSearch: PropTypes.func.isRequired,
  logo: PropTypes.string.isRequired,
  instanceName: PropTypes.string.isRequired,
  onSelectShowMore: PropTypes.func
};

export default Header;
